import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NeptingService {
  constructor() { }

  getForm(data: any) {
    console.log("[TYPAGE] : getForm(any) :", data)
    //  5071004150123060   06/25  000
    const form = document.createElement("form");
    form.target = "_self";
    form.method = "POST";
    form.action = "https://qualif.nepting.com/epay/payment";
    const params = data.tokenNepting;

    for (const i in params) {
      if (params.hasOwnProperty(i)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}
